export const EntityKeys = [
	'absences',
	'colorDefinitions',
	'contactCodes',
	'contactCodeTrees',
	'customPages',
	'customProperties',
	'pauseReasons',
	'permissions',
	'queues',
	'roles',
	'ruleSets',
	'settings',
	'skillGroups',
	'skills',
	'teams',
	'templates',
	'userGroups',
	'users',
] as const

export type EntityKey = (typeof EntityKeys)[number]

export function isEntityKey(value: string): value is EntityKey {
	return (EntityKeys as readonly string[]).includes(value)
}
